// Pure seeding decision for the Convert item-selection modal (B6, 2026-07-26).
// Extracted so the offline QA gate can EXECUTE the decision (no React) rather
// than assert on source regex.
//
// The rule:
//   - When the client PRE-SELECTED items on the public presentation, the
//     picker seeds included=true ONLY for those picks (everything else off) —
//     the rep opens straight to the client's choices and can still override
//     any checkbox.
//   - When there are NO client selections, every row starts checked — the
//     long-standing all-on default is untouched.

/**
 * Build the initial included-map for the convert picker.
 * @param itemIds        every source item id in the picker (order irrelevant)
 * @param preselectedIds the client's picks, or null/empty for "no selections"
 * @returns Record<itemId, included>
 */
export function seedConvertIncluded(
  itemIds: ReadonlyArray<string>,
  preselectedIds: ReadonlyArray<string> | null | undefined,
): Record<string, boolean> {
  const hasPicks = Array.isArray(preselectedIds) && preselectedIds.length > 0;
  const picks = hasPicks ? new Set(preselectedIds) : null;
  const out: Record<string, boolean> = {};
  for (const id of itemIds) {
    // No picks → all-on (unchanged default). Picks → only the picks are on.
    out[id] = picks === null ? true : picks.has(id);
  }
  return out;
}
